import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=bc3d1c2a&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=js&"
export * from "./InfoBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InfoBar.vue?vue&type=style&index=1&id=bc3d1c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3d1c2a",
  null
  
)

export default component.exports